import { makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  container: {
    "&:focus-within": {
      "& $icon": {
        color: "#545454"
      },
      border: "1px solid #aaaaaa"
    },
    backgroundColor: "#ffffff",
    border: "1px solid #e6e6e6",
    borderRadius: 20,
    display: "block" as "block",
    height: "40px",
    lineHeight: "38px",
    padding: "0 11px"
  },
  icon: {
    color: "#777777",
    display: "inline-block" as "inline-block",
    height: 32,
    verticalAlign: "middle" as "middle",
    width: 32
  },
  input: {
    border: "none",
    display: "inline-block" as "inline-block",
    fontSize: "1.6rem",
    verticalAlign: "middle" as "middle",
    width: "calc(100% - 32px)",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem"
    }
  }
}));

interface IOwnProps {
  onChange?: (arg0: string) => void;
  onKeyDown?: (arg0: string) => void;
  placeholder?: string;
  value: string;
}

const SearchInputWithValue = ({ onChange, onKeyDown, placeholder, value: inputValue }: IOwnProps) => {
  const inputRef = React.createRef<HTMLInputElement>();
  const classes = useStyles();
  const handleContainerClick = React.useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e.currentTarget.value);
      }
    },
    [onChange]
  );

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value.trim();
      if (onKeyDown && event.key === "Enter") {
        onKeyDown(value);
      }
    },
    [onkeypress]
  );

  return (
    <div onClick={handleContainerClick} className={classes.container}>
      <Search className={classes.icon} />
      <input
        placeholder={placeholder}
        onChange={handleChange}
        value={inputValue}
        onKeyDown={handleKeyDown}
        className={classes.input}
        ref={inputRef}
        type="text"
      />
    </div>
  );
};

export default SearchInputWithValue;
